<woa-full-page-layout [showNavbar]="configurationModel.showExitButton()" [hideBackButton]="true"
                      [transparent]="!(initialised() && allowActions())"
                      [title]="appDeviceService.deviceRegistrationRequired() ? 'woa.heading.entry.registerDevice' : undefined"
                      [showLoginBackgroundImage]="true">
    <div class="entry">
        @if (appDeviceService.isDevice()) {
            <woa-icon-button class="entry-nav-menu"
                             [type]="IconButtonType.MENU" [disabled]="!allowActions()"
                             (onActivate)="navigationService.createPage('woa-nav-menu-page', undefined, {alignment: PageAlignment.LEFT})"></woa-icon-button>
        }
        @if (demoMode() && !urlDisplayed()) {
            <woa-icon-button class="entry-settings"
                             [type]="IconButtonType.SETTINGS" (onActivate)="openChangeURL()"></woa-icon-button>
        }
        @if (urlDisplayed()) {
            <woa-text-field class="entry-url" [(ngModel)]="serverURL"
                            [type]="'url'" [label]="'woa.label.entry.url'"></woa-text-field>
        }
        <div class="entry-body">
            @if (initialised() == false) {
                <div class="entry-body-error">
                    @if (!appDeviceService.deviceRegistrationRequired()) {
                        <div class="entry-body-error-title">
                            {{ 'woa.heading.entry.error' | translate }}
                        </div>
                        @if (!deviceNotPresent()) {
                            <div class="entry-body-error-message">
                                {{ 'woa.error.entry.loginFailed' | translate }}
                            </div>
                        }
                        @if (deviceNotPresent()) {
                            <woa-content-message [level]="MessageLevel.ERROR"
                                                 [text]="'woa.error.entry.deviceNotPresent'"
                                                 [translationParams]="{'deviceName': appDeviceService.deviceName()}"
                                                 [closable]="false"></woa-content-message>
                        }
                    }
                </div>
            }
            @if (initialised() || appDeviceService.deviceRegistrationRequired()) {
                @if (allowActions() || appDeviceService.deviceRegistrationRequired()) {
                    <woa-logo class="entry-body-logo" [type]="'vertical'"></woa-logo>
                }
                @if (messageLine1() | translate | trim) {
                    <div class="entry-body-heading"
                         [innerHTML]="messageLine1() | translate: {'deviceName': appDeviceService.deviceName()} | html"></div>
                }
                @if (messageLine2() | translate | trim) {
                    <div class="entry-body-message"
                         [innerHTML]="messageLine2() | translate: {'appName': configurationModel.app()?.shortAppName, 'deviceName': appDeviceService.deviceName()} | html"></div>
                }
                @if (messageLine3() | translate | trim) {
                    <div class="entry-body-postscript"
                         [innerHTML]="messageLine3() | translate | html"></div>
                }
            }
        </div>
        <woa-form (onSubmit)="confirmWaiterName()">
            @if (showWaiterNameEntry()) {
                <woa-text-field class="entry-waiter-name" [(ngModel)]="waiterName"
                                required [label]="'woa.label.entry.waiterName'"
                                [placeholder]="'woa.label.entry.waiterNamePlaceholder'"></woa-text-field>
            }
        </woa-form>
    </div>
    @if (urlDisplayed()) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.common.cancel'"
                    [prominence]="ButtonProminence.LOW" [connotation]="ButtonConnotation.NEGATIVE"
                    (onActivate)="cancelURL()"></woa-button>
    }
    @if (urlDisplayed()) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.common.save'"
                    (onActivate)="saveURL()"></woa-button>
    }
    @if (showExitButton()) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.entry.exit'"
                    [prominence]="ButtonProminence.LOW" [connotation]="ButtonConnotation.NEGATIVE"
                    [style]="ButtonStyle.OUTLINE"
                    (onActivate)="appDeviceService.exitToAppDevice()"></woa-button>
    }
    @if (showRetryButton()) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.entry.retryInitialLogin'"
                    [prominence]="ButtonProminence.HIGH" [style]="ButtonStyle.FLAT"
                    (onActivate)="retryInitialisation()"></woa-button>
    }
    @if (showStartAsGuestButton()) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.entry.startOrder'" [prominence]="ButtonProminence.LOW"
                    (onActivate)="startAsGuest()"></woa-button>
    }
    @if (showStartAsGuestButton()) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.entry.startOrder'" [prominence]="ButtonProminence.LOW"
                    (onActivate)="startAsGuest()"></woa-button>
    }
    @if (showWaiterNameEntry()) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.entry.startOrder'" [prominence]="ButtonProminence.LOW"
                    (onActivate)="form().submit()"></woa-button>
    }
    @if (showLoginButtons()) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.entry.login'" [prominence]="ButtonProminence.LOW"
                    (onActivate)="identify(IdentificationMode.LOGIN)"></woa-button>
    }
    @if (showRegisterButton()) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.entry.register'"
                    (onActivate)="identify(IdentificationMode.REGISTER)"></woa-button>
    }
    @if (showLoginButtons()) {
        <woa-link woa-page-footer-control class="skip-login"
                  [link]="'woa.button.entry.skipLogin'"
                  (onActivate)="startAsGuest()"></woa-link>
    }
</woa-full-page-layout>
